import { useContext, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { ClaimsComponent } from '@/_shared/components/Claims';
import { LayoutContext } from '@/_shared/components/PageLayout';
import { Roles } from '@/_shared/constants/roles';
import { Admin, Learning } from '../components';

export const AiPlaygroundScreen = () => {
  const t = useTranslations('aiPlayground');
  const { setLayout } = useContext(LayoutContext);

  useEffect(() => {
    setLayout({ title: 'aiPlayground' });
  }, [setLayout, t]);

  return (
    <>
      <ClaimsComponent roles={[Roles.Admin, Roles.HR_Delegate]}>
        <>
          <Admin.LandingPlayground />
          <Admin.TrainingSoftSkillsAdmin />
        </>
      </ClaimsComponent>
      <ClaimsComponent roles={[Roles.Manager, Roles.Employee]}>
        <Learning.LandingPlayground />
      </ClaimsComponent>
    </>
  );
};
